"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fhLog = exports.FHLog = void 0;
class FHLog {
    constructor() {
        this.log = (...args) => {
            console.log('FeatureHub/Log: ', ...args);
        };
        this.error = (...args) => {
            console.error('FeatureHub/Error: ', ...args);
        };
        this.trace = (...args) => {
        };
    }
    quiet() {
        FHLog.fhLog.log = () => {
        };
        FHLog.fhLog.error = () => {
        };
        FHLog.fhLog.trace = () => {
        };
    }
}
exports.FHLog = FHLog;
FHLog.fhLog = new FHLog();
exports.fhLog = FHLog.fhLog;
//# sourceMappingURL=feature_hub_config.js.map